import React, { useContext } from 'react'

import CheckoutContext from 'contexts/Checkout'
import Layout from 'layouts/Layout'
import SkinsSlider from 'components/skins/SkinsSlider'

const Skins = () => {
  const { addLineItemsToCart } = useContext(CheckoutContext)

  const handleSkinQuantityChange = (quantity, product, variant) => {
    const lineItems = [
      {
        variantId: variant.id,
        quantity,
        product,
        variant
      }
    ]

    addLineItemsToCart(lineItems)
  }

  return (
    <Layout hideHeader>
      <SkinsSlider handleSkinQuantityChange={handleSkinQuantityChange} />
    </Layout>
  )
}

export default Skins
